import axios from 'axios'
import { REMARCAR_RESERVA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER, handleResponseError } from '../../util/responseUtil'
import { URL } from '../../util/ambienteActions'

const OFFLINE_AWARE_CONFIG = {
  headers: {
    ...SLOW_REQUEST_CONFIG.headers,
    [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
  }
}

function erroOffline() {
  const err = new Error('Sem conexão com a internet. A remarcação requer conexão. Tente novamente.')
  err.offline = true
  return Promise.reject(err)
}

export default function remarcarReservas(reservas) {
  const url = `${URL}/reserva/remarcar-reservas`
  return async dispatch => {
    if (!navigator.onLine) {
      return erroOffline()
    }
    return axios.post(url, reservas, OFFLINE_AWARE_CONFIG)
      .then(response => dispatch({ type: REMARCAR_RESERVA, payload: response }))
      .catch(error => {
        if (!error.response) {
          return erroOffline()
        }
        handleResponseError(error.response.data)
        throw error
      })
  }
}
